export default __webpack_public_path__ + "static/media/2196.56e541ca.png";